<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 33428 33428"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="33428" height="33428" rx="3260" ry="3260"/>
  <g id="_811107496">
   <path class="fil1" d="M10490 16091c251,19 1105,438 1404,579l1237 574c67,40 65,41 98,68 -354,315 -2417,1711 -2909,2075l-3668 2599c-256,179 -537,341 -738,513 -337,289 -208,654 222,684 394,28 856,-3 1257,-3l14988 0c1062,0 1646,288 1413,-1015 -136,-765 -335,-1175 -738,-1765 -680,-996 -1377,-1928 -2072,-2943 -1020,-1490 -1368,-1482 -2805,-2156 -1153,-541 -2309,-1036 -3449,-1566 -421,-195 -3071,-1403 -3488,-1524 -1387,-405 -2737,201 -3553,1236l-1698 2012c-445,516 -1441,1616 -1592,2167 -415,1509 910,2732 2407,2303 702,-201 975,-671 1389,-1112 199,-212 363,-439 579,-675 183,-202 377,-467 573,-680l1143 -1371z"/>
   <path class="fil1" d="M5002 24773c-1236,388 -956,1695 -288,2037 496,253 2665,137 3381,137 2319,-3 4650,32 6968,7 2300,-25 4669,-40 6967,-3 852,13 6562,58 6942,-42 938,-248 1131,-1533 233,-2032 -456,-253 -2680,-160 -3366,-149 -2291,40 -4674,29 -6967,-2 -567,-7 -13586,-43 -13870,47z"/>
   <path class="fil1" d="M25064 12518c-1975,241 -3534,1885 -3327,4141 173,1888 1930,3578 4067,3336 1974,-223 3516,-1910 3344,-4138 -147,-1906 -1922,-3601 -4084,-3339z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'SwimmingPool',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#00A0E3}
</style>
